import { render, staticRenderFns } from "./ReferencePage.vue?vue&type=template&id=20d2a11b&scoped=true"
import script from "./ReferencePage.vue?vue&type=script&lang=js"
export * from "./ReferencePage.vue?vue&type=script&lang=js"
import style0 from "./ReferencePage.vue?vue&type=style&index=0&id=20d2a11b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d2a11b",
  null
  
)

export default component.exports